import { Box, Button, TextField, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useUserContext } from "../../providers/userProvider";
import { useNavigate } from "react-router-dom";
import Logo from "../../pictures/Re-evented.webp";
import { useCustomThemeContext } from "../../providers/customThemeProvider";

// Define the ForgotPasswordPage functional component
export const ForgotPasswordPage: FC = () => {
  const { updateTheme } = useCustomThemeContext();
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | undefined>();
  const [message, setMessage] = useState<string | undefined>();
  const { resetPassword } = useUserContext();
  const navigate = useNavigate();

  // Update the theme when the component mounts
  useEffect(() => {
    updateTheme();
  }, []);

  // Function to handle the password reset process
  const onResetPassword = async () => {
    const result = await resetPassword(email);

    if (result.error) {
      setError(result.error);
    } else {
      setMessage("Password reset email sent. Please check your inbox.");
    }
  };

  return (
    <Box
      height={"100vh"}
      display={"flex"}
      flexDirection={"column"}
      width={1}
      sx={{
        background: "#e2e2e2",
      }}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        flexGrow={1}
        p={2}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          p={5}
          width={1}
          maxWidth={350}
          borderRadius={4}
          sx={{ background: "white" }}
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            width={1}
          >
            <Box
              display="flex"
              flexDirection="column"
              maxWidth="500px"
              width={1}
              padding={2}
              gap={2}
            >
              <Box
                src={Logo}
                component="img"
                alt={"Logo"}
                width={250}
                height={100}
                mb={2}
                alignSelf={"center"}
                sx={{ objectFit: "contain" }}
              />
              <Typography
                variant="h4"
                alignContent={"center"}
                alignSelf={"center"}
                textAlign={"center"}
              >
                Forgot Password
              </Typography>
              <TextField
                variant="outlined"
                label="Email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={onResetPassword}
              >
                Reset Password
              </Button>
              {/* Display error message if there is an error */}
              {error && <Typography color="error">{error}</Typography>}
              {/* Display success message if the email was sent */}
              {message && <Typography color="primary">{message}</Typography>}
              {/* Navigate to the login page */}
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => navigate("/login")}
              >
                Back to Login
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
